import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { NoDataAvailableSVG } from '@common_components/svg/noDataAvailable.svg';

const NoDataAvailableIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className}`} onClick={onClick}>
      <NoDataAvailableSVG className={`w-${size} h-${size} inline-block align-middle`} />
    </div>
  );
};

export { NoDataAvailableIcon };
